window.addEventListener('DOMContentLoaded', () => {
    const toggle = document.querySelector('[data-search-toggle]');

    if (!toggle) {
        return;
    }

    const searchField = document.querySelector('.topbar__search');
    const searchInput = document.querySelector('.search__input');

    toggle.addEventListener('click', (e) => {
        if (document.querySelector('.search__input').offsetParent !== null) {
            return;
        }
        searchField.classList.add('topbar__search--active');
        searchInput.focus();
    });

    document.querySelector('.search__close').addEventListener('click', (e) => {
        searchField.classList.remove('topbar__search--active');
    })
});